import { render, staticRenderFns } from "./platformGoodsList.vue?vue&type=template&id=7ff9a1d9&scoped=true"
import script from "./platformGoodsList.vue?vue&type=script&lang=js"
export * from "./platformGoodsList.vue?vue&type=script&lang=js"
import style0 from "./platformGoodsList.vue?vue&type=style&index=0&id=7ff9a1d9&prod&lang=scss&scoped=true"
import style1 from "./platformGoodsList.vue?vue&type=style&index=1&id=7ff9a1d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff9a1d9",
  null
  
)

export default component.exports